export function IconUWICardMobile() {
  return (
    <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.208984" width="54" height="54" rx="6" fill="white" fillOpacity="0.2" />
      <path
        d="M45 18.209C43.0553 18.2083 41.1107 20.875 39.166 26.209C35.2772 36.8757 31.3884 36.8757 27.4996 26.209C23.6108 15.5423 19.722 15.5423 15.8332 26.209C13.8888 31.5423 11.9444 34.209 10 34.209"
        stroke="white"
        strokeWidth="3"
      />
      <path
        d="M45 24.209C43.0553 24.2088 41.1107 24.8755 39.166 26.209C35.2772 28.8757 31.3884 28.8757 27.4996 26.209C23.6108 23.5423 19.722 23.5423 15.8332 26.209C13.8888 27.5423 11.9444 28.209 10 28.209"
        stroke="white"
        strokeOpacity="0.5"
        strokeWidth="1.5"
      />
    </svg>
  )
}
